export default __webpack_public_path__ + "static/media/something_went_wrong.3009f597.png";